export default __webpack_public_path__ + "static/commmune-airbnb_adopted-7da92849da75378407c0074ff1496b44.png";